import { createZodDto } from './zod';

import { z } from 'zod';

export const CreateUpdateMedicalVisitTypeSchema = z.object({
  code: z.string().min(1),
  label: z.string().min(1),
  periodicityMonths: z.number().int().positive().nullable(),
  // Display-only informational deadline, see MedicalVisitType.initialDeadlineMonths
  initialDeadlineMonths: z
    .number()
    .int()
    .nonnegative()
    .nullable()
    .default(null),
  // Pre-checked at employee creation time, see MedicalVisitType.isDefault
  isDefault: z.boolean().default(false),
});

export class MedicalVisitTypeCreateUpdateDto extends createZodDto(
  CreateUpdateMedicalVisitTypeSchema,
) {}

export const SetUserMedicalVisitTypesSchema = z.object({
  typeIds: z.array(z.number().int().positive()),
});

export class SetUserMedicalVisitTypesDto extends createZodDto(
  SetUserMedicalVisitTypesSchema,
) {}
